const UserTypes = Object.freeze({
  student: "STUDENT",
  other: "OTHER",
  admin: "ADMIN",
  demoOther: "DEMO-OTHER",
  demoStudent: "DEMO-STUDENT",
});

export default UserTypes;
